export const defaultState = {
  activeContracts: [],
  expiredContracts: [],
  selectedContract: {},
  positionRequestTypes: [],
  internalCRTRequests: [],
  externalCRTRequests: [],
  crtStatuses: [],
};
